



















import { defineComponent, computed, ref, watch } from '@vue/composition-api';

export default defineComponent({
  props: {
    currentTime: { type: Number, default: 0 },
    duration: { type: Number, default: 0 },
  },
  setup(props, ctx) {
    const isSeeking = ref(false);
    const seekVal = ref(0);
    const progress = computed({
      get: () => (isSeeking.value ? seekVal.value : props.currentTime),
      set: (val: string | number) => {
        if (isSeeking.value) seekVal.value = typeof val === 'string' ? parseFloat(val) : val;
      },
    });
    watch(
      () => isSeeking.value,
      (val, oldVal) => !val && oldVal && ctx.emit('seeked', seekVal.value)
    );
    return {
      progress,
      isSeeking,
    };
  },
});
